import React from 'react';
import proptypes from 'prop-types';
const { bool, string } = proptypes;
import classnames from 'classnames';
import { PodSection } from '@thd-olt-component-react/product-pod';
import { InfoDrawer } from '../InfoDrawer';
import { useApplianceBundles } from '../../ApplianceBundlesProvider';
import { drawerDataShape } from '../../ApplianceBundlesShape';

export const ItemPodHeader = ({ isAnchor, heading, drawerData }) => {
  const { hasMobileView } = useApplianceBundles();

  const headerClassNames = classnames('sui-flex sui-items-center sui-text-sm sui-font-w-bold sui-h-7', {
    'sui-bg-strong': isAnchor,
    'sui-py-1 sui-justify-center': isAnchor || !hasMobileView
  });

  return (
    <div className={headerClassNames}>
      {heading}
      <InfoDrawer drawerData={drawerData} />
    </div>
  );
};

ItemPodHeader.propTypes = {
  isAnchor: bool.isRequired,
  heading: string.isRequired,
  drawerData: drawerDataShape.isRequired
};